<template>
  <div class="container py-4">
    <h3 class="mb-3">Crear Proveedor</h3>

    <form @submit.prevent="guardar">
      <div class="card">
        <div class="card-body">
          <div class="row gy-3">
            <div class="col-md-3">
              <label class="form-label">Company ID</label>
              <input type="number" class="form-control form-control-sm" v-model.number="form.empresa_id" required />
            </div>

            <div class="col-md-3">
              <label class="form-label">Tipo Identificación (SRI)</label>
              <select class="form-select form-select-sm" v-model="form.identification_type_sri_code" required>
                <option value="04">RUC</option>
                <option value="05">Cédula</option>
                <option value="06">Pasaporte</option>
              </select>
            </div>

            <div class="col-md-3">
              <label class="form-label">Identificación</label>
              <input type="text" class="form-control form-control-sm" v-model.trim="form.identification_number" required />
            </div>

            <div class="col-md-3">
              <label class="form-label">Tipo Contribuyente</label>
              <select class="form-select form-select-sm" v-model="form.taxpayer_type">
                <option value="natural">Natural</option>
                <option value="juridico">Jurídico</option>
              </select>
            </div>

            <div class="col-md-6">
              <label class="form-label">Razón Social</label>
              <input type="text" class="form-control form-control-sm" v-model.trim="form.business_name" required />
            </div>

            <div class="col-md-6">
              <label class="form-label">Nombre Comercial</label>
              <input type="text" class="form-control form-control-sm" v-model.trim="form.trade_name" />
            </div>

            <div class="col-md-6">
              <label class="form-label">Email</label>
              <input type="email" class="form-control form-control-sm" v-model.trim="form.email" />
            </div>

            <div class="col-md-6">
              <label class="form-label">Teléfono</label>
              <input type="text" class="form-control form-control-sm" v-model.trim="form.phone" />
            </div>

            <div class="col-md-4">
              <label class="form-label">País</label>
              <input type="text" class="form-control form-control-sm" v-model.trim="form.country" placeholder="Ecuador" />
            </div>

            <div class="col-md-4">
              <label class="form-label">Provincia</label>
              <input type="text" class="form-control form-control-sm" v-model.trim="form.province" />
            </div>

            <div class="col-md-4">
              <label class="form-label">Cantón</label>
              <input type="text" class="form-control form-control-sm" v-model.trim="form.canton" />
            </div>

            <div class="col-md-12">
              <label class="form-label">Dirección</label>
              <input type="text" class="form-control form-control-sm" v-model.trim="form.address" />
            </div>

            <div class="col-md-6">
              <label class="form-label">Agente de Retención</label>
              <select class="form-select form-select-sm" v-model="form.retention_agent">
                <option value="no">No</option>
                <option value="si">Sí</option>
              </select>
            </div>

            <div class="col-md-6">
              <label class="form-label">Activo</label>
              <select class="form-select form-select-sm" v-model="form.is_active">
                <option :value="1">Sí</option>
                <option :value="0">No</option>
              </select>
            </div>

            <div class="col-md-12">
              <label class="form-label">Observaciones</label>
              <textarea class="form-control form-control-sm" v-model.trim="form.observations" rows="3"></textarea>
            </div>
          </div>
        </div>

        <div class="card-footer d-flex justify-content-between">
          <router-link class="btn btn-outline-secondary btn-sm" to="/proveedores">
            Volver
          </router-link>
          <button type="submit" class="btn btn-primary btn-sm" :disabled="saving">
            <span v-if="saving" class="spinner-border spinner-border-sm" role="status"></span>
            <span v-else>Guardar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import supplierService from '@/services/supplierService';
import notificationService from '@/services/notificationService';

export default {
  name: 'ProveedorCrear',
  data() {
    return {
      saving: false,
      form: {
        empresa_id: null,
        identification_number: '',
        business_name: '',
        trade_name: '',
        address: '',
        country: 'Ecuador',
        province: '',
        canton: '',
        phone: '',
        email: '',
        taxpayer_type: 'natural',
        retention_agent: 'no',
        supplier_type: 'local',
        observations: '',
        is_active: 1,
        identification_type_sri_code: '04'
      }
    };
  },
  methods: {
    async guardar() {
      // Validaciones básicas
      if (!this.form.empresa_id) {
        this.mostrarNotificacion('Company ID es requerido', 'error');
        return;
      }
      if (!this.form.identification_number) {
        this.mostrarNotificacion('Número de identificación es requerido', 'error');
        return;
      }
      if (!this.form.business_name) {
        this.mostrarNotificacion('Razón social es requerida', 'error');
        return;
      }

      this.saving = true;
      try {
        const payload = { ...this.form };
        payload.empresa_id = Number(payload.empresa_id);
        payload.is_active = Number(payload.is_active);

        await supplierService.crear(payload);
        this.mostrarNotificacion('Proveedor creado correctamente', 'success');
        this.$router.push('/proveedores');
      } catch (e) {
        console.error('Error creando proveedor', e);
        const msg = e?.response?.data?.error || e.message || 'No se pudo crear el proveedor';
        this.mostrarNotificacion(msg, 'error');
      } finally {
        this.saving = false;
      }
    },
    mostrarNotificacion(mensaje, tipo = 'info') {
      if (tipo === 'success') notificationService.success(mensaje);
      else if (tipo === 'error') notificationService.error(mensaje);
      else notificationService.info(mensaje);
    }
  }
};
</script>

<style scoped>
.card { overflow: hidden; }
</style>